import { Component, NgZone } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';
import { DateService } from '../../shared/services/date.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewDisputeComponent } from './view-dispute/view-dispute.component';

@Component({
  standalone: false,
  selector: 'app-disputes',
  templateUrl: './disputes.component.html',
  styleUrl: './disputes.component.scss'
})
export class DisputesComponent {

  gridApi: any;
  apiUrl: any;

  constructor(private _api: ApiService,
    private _dateService: DateService,
    private zone: NgZone,
    private modalService: NgbModal,
  ) {

  }

  columnDefs: ColDef[] = [
    {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.onView(params);
          });
        });
        return button;
      }
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    }, 
    {
      headerName: 'Customer Name',
      field: 'customerId.name',
      editable: false,
      filter: true,
      width: 250,
    },
    // {
    //   headerName: 'Customer EmailId',
    //   field: 'customerId.emailId',
    //   editable: false,
    //   filter: true,
    // },
    {
      headerName: 'Merchant Name',
      field: 'transactionId.merchantName',
      editable: false,
      filter: true,
      width: 250,
    },
    // {
    //   headerName: 'Origination Country',
    //   field: 'transactionId.originationCountry',
    //   editable: false,
    //   filter: true,
    // },
    // {
    //   headerName: 'Recipient Country',
    //   field: 'transactionId.recipientCountry',
    //   editable: false,
    //   filter: true,
    // },
    // {
    //   headerName: 'Transaction Id',
    //   field: 'transactionId._id',
    //   editable: false,
    //   filter: true,
    // },
    {
      headerName: 'Transaction Date',
      field: 'transactionId.createdAt',
      editable: false,
      filter: true,
      valueFormatter: (params) =>
        this._dateService.getFormattedDateWithAMPM(params.value)
    },
    {
      headerName: 'Amount',
      field: 'transactionId.conversions',
      editable: false,
      filter: true,
      valueGetter: (params) => {
        try {
          const conversions = JSON.parse(params.data.transactionId.conversions);
          return conversions.customerPays.currency+' '+conversions.customerPays.amount;
        } catch (e) {
          return '0';
        }
      }
    }
  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
      // setTimeout(() => {
      //   const column = vm.gridApi.getColumnDef('transactionId.createdAt');
      //   if (column) {
      //     vm.gridApi.autoSizeColumns([column.field]);
      //   }
      // }, 200);
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;
        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        this.apiUrl = '/admin/disputes/' + '?_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(function (k) {
          if (k && filterData[k]) {
            var filterValue = String(filterData[k].filter).replace(/[<>"';&]/g, '').slice(0, 200);
            if (!filterValue) return;
            if (k === 'amount') {
              vm.apiUrl += "&" + k + "_FULLMATCH=" + encodeURIComponent(filterValue);
            } else {
              vm.apiUrl += "&" + k + "_like=" + encodeURIComponent(filterValue);
            }
          }
        });
        vm._api.getData(this.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            const dt: any = [];
            Object.keys(res.data).map(r => {
              const obj = { type: r, value: res.data[r] };
              dt.push(obj);
            });
            console.log(dt);
            res.data.value = dt;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  onView(params: any) {
    const vm = this;
    const modalRef = this.modalService.open(ViewDisputeComponent, { backdrop: 'static', size: 'lg' });
    modalRef.componentInstance.disputeData = params.data;
    modalRef.componentInstance.onSave.subscribe(() => {
      vm.gridApi.refreshInfiniteCache();
    });
  }

}
